import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './public/components/Navbar';
import Footer from './public/components/Footer';

function Public() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default Public;
